import { Box, LinearProgress, LinearProgressProps, Typography } from "@mui/material";
import { tss } from "tss-react";

const useStyles = tss.create({
    root: {
        width: "100%",
    },
});

export default function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    const { classes } = useStyles();
    return (
        <div className={classes.root}>
            <Box display="flex" alignItems="center">
                <Box width="100%" mr={1}>
                    <LinearProgress variant="determinate" {...props} />
                </Box>
                <Box minWidth={35}>
                    <Typography variant="body2" color="textSecondary">{`${Math.round(props.value)}%`}</Typography>
                </Box>
            </Box>
        </div>
    );
}
